import { catchAsync, IS_SUCCESS_RESPONSE } from "src/helpers";

import { Button, Table, TableBody, TableCell, TableRow } from "src/shadcn/components/ui";
import { createOrderApiRequest } from "src/services/requests/Order";
import { useEffect, useState } from "react";
import { useAuth } from "../Auth/Core";
import { useNavigate, useParams } from "react-router-dom";
import CustomeDialog from "src/shadcn/components/custom/CustomeDialog";
import { fetchQuotationProjectRequestApi } from "src/services/requests/Projects";

type Props = {};

const OrderConfirmationDetails = (props: Props) => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [projectDetails, setprojectDetails] = useState<any>(undefined);
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  if (!id) {
    navigate("/");
  }

  useEffect(() => {
    if (id) {
      handleFetchProjectDetails();
    }
    return () => {};
  }, [id]);

  const handleFetchProjectDetails = catchAsync(
    async () => {
      setIsLoading(true);
      return id && (await fetchQuotationProjectRequestApi(id));
    },
    (result: any) => {
      if (IS_SUCCESS_RESPONSE(result)) {
        setprojectDetails(result?.data);
        setIsLoading(false);
      }
    },
    () => {
      setIsLoading(false);
    }
  );

  const handleCreateOrder = catchAsync(
    async () => {
      setIsLoading(true);
      return await createOrderApiRequest({
        user_id: currentUser?.id,
        order_total: "1",
        total_price: projectDetails?.totalProjectCost,
        project_id: id,
      });
    },
    (result: any) => {
      if (IS_SUCCESS_RESPONSE(result)) {
        setIsLoading(false);
        setShowDialog(true);
        // navigate("/" + MAIN_ROUTES_CONST.payment + "/" + result?.order_id)
      }
    },
    () => {
      setIsLoading(false);
    }
  );

  return (
    <div className=" h-full w-full justify-center items-center space-y-4">
      <div className="flex flex-col space-y-8 mt-[200px] max-w-[30vw] mx-auto ">
        <div>
          <div className="text-center font-bold text-2xl text-primary">Order Confirmation</div>
        </div>
        <div>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell>Order Type</TableCell>
                <TableCell className="text-end">
                  <span className="font-semibold ">Service</span>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Product ID (#)</TableCell>
                <TableCell className="text-end">
                  <span className="font-semibold  uppercase">asdasdasdd</span>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Project Amount</TableCell>
                <TableCell className="text-end">
                  <span className="font-semibold ">₹ {projectDetails?.totalProjectCost} </span>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>EmI Duration</TableCell>
                <TableCell className="text-end">
                  <span className="font-semibold ">12 Months</span>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>EMI Amounts</TableCell>
                <TableCell className="text-end">
                  <span className="font-semibold ">₹ {projectDetails?.interestAmount} </span>
                </TableCell>
              </TableRow>
              {/* <TableRow>
                                <TableCell>Final Price</TableCell>
                                <TableCell><span className="font-semibold">₹ {selectedService?.overAllPrice} </span></TableCell>
                            </TableRow> */}
            </TableBody>
          </Table>
          <div className="flex justify-center">
            <Button isLoading={isLoading} onClick={() => handleCreateOrder()}>
              Confirm Order
            </Button>
          </div>
        </div>
      </div>
      <CustomeDialog
        isOpen={showDialog}
        headerTitle="Request Generated"
        hideDefaultCancle
        onSubmit={() => {
          navigate("/");
        }}
      >
        <p className="mb-4">Order Request initiated, our team will contact you soon.</p>
      </CustomeDialog>
    </div>
  );
};

export default OrderConfirmationDetails;
